var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.957,
    height: 15.957,
    viewBox: "0 0 15.957 15.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#454f63;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.707 0.707)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.7,15.215a6.657,6.657,0,0,1-3.927,1.362c-4.627,0-7.271-5.288-7.271-5.288A12.2,12.2,0,0,1,4.845,7.362m2.538-1.2A6.029,6.029,0,0,1,8.771,6c4.627,0,7.271,5.288,7.271,5.288A12.229,12.229,0,0,1,14.615,13.4m-4.442-.707a1.983,1.983,0,1,1-2.8-2.8",
    transform: "translate(-1.5 -4.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.5,1.5,16.043,16.043",
    transform: "translate(-1.5 -1.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherEyeOff);
export default __webpack_public_path__ + "static/media/feather-eye-off.f0d69d539d5ee94ed255b5963655ec82.svg";
export { ForwardRef as ReactComponent };